import type { ResourceType } from 'ui/resource-label/resource-label';

import type { DataSourceType } from 'cadenza/repository/model/data-source-type.gen';

export function getTableResourceType(dataSourceType: DataSourceType): ResourceType {
  switch (dataSourceType) {
    case 'ELASTIC':
      return 'index';
    case 'ARCGIS_REST':
      return 'arcGisLayer';
    case 'WFS':
      return 'wfsLayer';
    default:
      return 'datatable';
  }
}

export function getColumnResourceType(dataSourceType: DataSourceType): ResourceType {
  switch (dataSourceType) {
    case 'ELASTIC':
      return 'indexField';
    case 'ARCGIS_REST':
      return 'arcGisAttribute';
    default:
      return 'column';
  }
}

export function needsFlavor(dataSourceType: DataSourceType): boolean {
  return dataSourceType === 'RDBMS' || dataSourceType === 'ELASTIC';
}
